import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateExperienceChooserModal } from "components/CreateExperienceChooserModal";

export const LEGACY_CREATE_ROUTE = "/media/projects/create";
export const PLAYBOOKS_CREATE_ROUTE = "/create-experience";

/**
 * Shared entry for every "create experience" button: opens a
 * Playbooks-vs-Legacy chooser modal.
 *
 * Render the returned `chooserModal` next to the triggering button.
 */
export function useCreateExperienceEntry() {
  const navigate = useNavigate();
  const [isChooserOpen, setIsChooserOpen] = useState(false);

  const startCreateExperience = () => setIsChooserOpen(true);

  const closeChooser = () => setIsChooserOpen(false);

  const chooserModal = (
    <CreateExperienceChooserModal
      open={isChooserOpen}
      onClose={closeChooser}
      onChoosePlaybooks={() => {
        closeChooser();
        navigate(PLAYBOOKS_CREATE_ROUTE);
      }}
      onChooseLegacy={() => {
        closeChooser();
        navigate(LEGACY_CREATE_ROUTE);
      }}
    />
  );

  return { startCreateExperience, chooserModal };
}
